import React from 'react';
import LoadingSpinner from './Generic/LoadingSpinner';
import Card from './Generic/Card';
import RichTextDisplay from './Generic/RichTextDisplay';
import HTMLDocxLink from './Generic/HTMLDocxLink';
import { addClassNames } from '../Functions/Helper/Component';

const Description = (name, HTML) => () => <HTMLDocxLink HTML={HTML} rotate pageType='A3' name={name}> Download Role Alignment Capability Matrix</HTMLDocxLink>;

export default function MyRAC({role, className}) {
    const children = role.mcb_rac? <RichTextDisplay value={role.mcb_rac}/> : <LoadingSpinner/>;
    return (
        <Card
            title="Role Alignment Capability Matrix"
            className={addClassNames("w-100", className)}
            description="Downloads this Role Alignment Capability as MS Word Document"
            DescriptionControl={role?.mcb_rac && Description(`RAC - ${role.mcb_roletitle}`, role.mcb_rac)}
        >
            {children}
        </Card>
    );
}